export enum GlobalRole {
  admin = 'global.admin',
  admin_group = 'global.admin.group',
  admin_company = 'global.admin.company',
  admin_teams = 'global.admin.teams',
  admin_users = 'global.admin.users',
  admin_tags = 'global.admin.tags',
  admin_taxonomy = 'global.admin.taxonomy',
  admin_workflows = 'global.admin.workflows',
  admin_api = 'global.admin.api',
  admin_banners = 'global.admin.banners',
  library = 'global.library',
  collab = 'global.collab',
  project = 'global.collab.project',
  task = 'global.collab.task',
  planning = 'global.collab.plan',
  forecast = 'global.collab.forecast',
  wiki = 'global.wiki',
  export = 'global.export',
}
